<script>
    import {
        Icon,
        InputGroup,
        InputGroupText,
        Button,
        Input,
        Table,
    } from 'sveltestrap';

    import {colors, calcBurnRate, convertSectoDay, resetToDefaultAlertingWindows} from './slo.js'

    export let windows;

    function deleteTimeWindow(deleteIdx) {
        $windows = $windows.filter((value, idx) => {
            return deleteIdx !== idx
        })
    }

    function addAlertingWindow() {
        $windows.push({
            time_window: 1,
            error_budget_burned_percent: 1,
            alert: 'Page'
        })

        $windows = $windows
    }


</script>
<Table striped size="sm">
    <thead>
    <tr>
        <th class="text-center">&nbsp;</th>
        <th class="text-center">Error budget consumed</th>
        <th class="text-center">Long window</th>
        <th class="text-center">Short window</th>
        <th class="text-center">Burn rate</th>
        <th class="text-center" style="min-width: 100px">Alert type</th>
        <th class="text-center">Delete</th>
    </tr>
    </thead>
    <tbody>
    {#each $windows as window, idx}
        <tr>
            <td class="text-center align-middle">
                <Icon style="color: {colors[idx]}" name="circle-fill"/>
            </td>
            <td class="text-center">
                <InputGroup>
                    <Input


                            type="number"
                            name="slo_consumption"
                            id="slo_consumption"
                            placeholder="number placeholder"
                            bind:value="{window.error_budget_burned_percent}"
                    />
                    <InputGroupText>%</InputGroupText>
                </InputGroup>
            </td>
            <td class="text-center">
                <InputGroup>

                    <Input

                            type="number"
                            name="time_window"
                            id="time_window"
                            placeholder="number placeholder"
                            bind:value="{window.time_window}"
                    />
                    <InputGroupText>h</InputGroupText>

                </InputGroup>

            </td>

            <td class="text-center align-middle">
                {convertSectoDay(window.time_window / 12 * 3600)}
            </td>
            <td class="text-center align-middle">
                {calcBurnRate(window.time_window, window.error_budget_burned_percent).toFixed(2)}
            </td>

            <td class="text-center">
                <Input type="select" name="alert" id="alert"
                       bind:value="{window.alert}"
                >
                    <option>Page</option>
                    <option>Ticket</option>
                </Input>
            </td>

            <td class="text-center">
                <Button color="danger" on:click={() => deleteTimeWindow(idx)} outline>
                    <Icon name="trash"/>
                </Button>

            </td>

        </tr>
    {/each}
    {#if $windows.length === 0}
        <tr>
            <td colspan="7" class="text-center align-middle">Nothing to see here :)</td>
        </tr>
    {/if}
    <tr>
        <td>&nbsp;</td>
        <td colspan="4">
            <Button color="secondary" on:click={resetToDefaultAlertingWindows} outline>
                <Icon name="backspace"/>
                Reset to default
            </Button>
        </td>
        <td>&nbsp;</td>
        <td class="text-center">
            <Button color="primary" on:click={addAlertingWindow} disabled={$windows.length >= 4} outline>
                <Icon name="plus"/>
            </Button>
        </td>
    </tr>
    </tbody>
</Table>


